import { useHistory } from "react-router-dom";

export const MembershipDetails = () => {
    const history = useHistory();
    return (
        <div className="help-center-wrapper">
            <div className="help-center-details-container">
                <div className="help-center-header">
                    <div className="w-100 tap-flex-center justify-content-start">
                        <div className="nb-link-underline-500 w-auto cursor-pointer" onClick={()=> history.goBack()}>
                            Back
                        </div>
                    </div>
                    <h3>
                        Managing Your Membership
                    </h3>

                    <p className="help-center-text break-word">
                        Nobilis is more than a network — it is a philosophy. <br />
                        Our members are leaders, creators, and visionaries who seek more than exposure; they seek alignment, growth, and deeper resonance with others walking a similar path.
                    </p>
                </div>

                <div className="help-center-content">
                    <span className="text-bold">We believe:</span>

                    <ul className="help-center-ul">
                        <li>Access is a privilege. It is earned through values, not status.</li>
                        <li>Connection is sacred. True conversation starts with presence and purpose.</li>
                        <li>Legacy matters. We build not just for now, but for what follows.</li>
                        <li>Time is luxury. We protect it, offer it with intention, and value those who do the same.</li>
                        <li>Discretion is the foundation. Trust is everything — and it is never compromised.</li>
                    </ul>

                    <p className="subtext">
                        Nobilis exists to gather those who lead quietly, think deeply, and act meaningfully. This ethos lives in every conversation, every meeting, and every invitation extended.
                    </p>
                </div>
            </div>
        </div>
    )
}